document.addEventListener("DOMContentLoaded", function () {
    const hamburger = document.querySelector(".hamburger");
    const overlay = document.querySelector(".overlay");
    const overlayContent = document.getElementById("overlay-content");
    const header = document.querySelector(".header");
    const closeOverlay = document.getElementById("overlay-close");
    const items = document.querySelectorAll(".header-menu");
    const toSecondButtons = document.querySelectorAll(".to-second");
    const toThirdButtons = document.querySelectorAll(".to-third");

    toThirdButtons.forEach(btn => {
        btn.addEventListener("click", () => {

            const linkClass = [...btn.classList].find(c => c.startsWith("link-"));
            if (!linkClass) return;
            const nums = linkClass.replace("link-", "");

            const target = document.querySelector(`.link-menu-${nums}`);
            if (!target) return;

            document.querySelectorAll("[class*='link-menu-']").forEach(el => {
                const parts = el.className.match(/link-menu-\d+-\d+/);
                if (parts) {
                    el.classList.remove("active-list", "opacity-100", "translate-x-0");
                    el.classList.add("opacity-0", "-translate-x-10");
                }
            });

            target.classList.add("active-list", "opacity-100", "translate-x-0");
            target.classList.remove("opacity-0", "-translate-x-10");

                            console.log(`.arrow-container-${nums.split("-")[0]}`);

            document.querySelectorAll(`.arrow-container-${nums.split("-")[0]}`).forEach(a => {
                a.classList.add("opacity-0");
                a.classList.remove("opacity-100");
            });
            const arrow = document.querySelector(`.arrow-container-${nums}`);
            if (arrow) {
                arrow.classList.add("opacity-100");
                arrow.classList.remove("opacity-0");
            }
        });
    });

    toSecondButtons.forEach(btn => {
        btn.addEventListener("click", () => {

            const linkClass = [...btn.classList].find(c => c.startsWith("link-"));
            if (!linkClass) return;
            const num = linkClass.replace("link-", "");

            const target = document.querySelector(`.link-menu-${num}`);
            if (!target) return;

            document.querySelectorAll("[class*='link-menu-']").forEach(el => {
                const parts = el.className.match(/link-menu-(\d+)(-\d+)?/);
                if (!parts) return;

                if (!parts[2]) {
                    el.classList.remove("active-list", "opacity-100", "translate-x-0");
                    el.classList.add("opacity-0", "-translate-x-10");
                }
            });

            target.classList.add("active-list", "opacity-100", "translate-x-0");
            target.classList.remove("opacity-0", "-translate-x-10");

            document.querySelectorAll('[class*="arrow-container-"]').forEach(a => {
                if ([...a.classList].some(c => c.startsWith("arrow-container-"))) {
                    a.classList.add("opacity-0");
                    a.classList.remove("opacity-100");
                }
            });

            const arrow = document.querySelector(`.arrow-container-${num}`);
            if (arrow) {
                arrow.classList.add("opacity-100");
                arrow.classList.remove("opacity-0");
            }
        });
    });

    items.forEach(item => {
        item.addEventListener("click", () => {
            items.forEach(i => i.classList.remove("active-div"));
            item.classList.add("active-div");
        });
    });

    hamburger.addEventListener("click", function () {
        overlay.classList.remove("hidden");
        header.classList.add("hidden");
        requestAnimationFrame(() => {
            overlayContent.classList.remove("-translate-x-full");
        });
    });

    closeOverlay.addEventListener("click", function () {
    requestAnimationFrame(() => {
        overlayContent.classList.add("-translate-x-full");
    });
    setTimeout(() => {
        overlay.classList.add("hidden");
        header.classList.remove("hidden");
    }, 300); 
});

});
